import React from 'react';
import { ThemeProvider } from 'styled-components';
import 'styled-components';

import playupTheme from './playupTheme';

type PlayupTheme = typeof playupTheme;
declare module 'styled-components' {
	export interface DefaultTheme extends PlayupTheme {}
}

const PlayupThemeProvider = ({ children }: { children: React.ReactNode }) => (
	<ThemeProvider theme={playupTheme}>{children}</ThemeProvider>
);

export default PlayupThemeProvider;
